import { http } from '../../services/http'

const state = {
  categories: [],
  productToCategory: [],
  showInactive: true
}

const getters = {
  categories(state) {
    if (state.showInactive) {
      return state.categories
    }
    return state.categories.filter(c => {
      return c.status == 1
    })
  },
  categoriesSelect(state) {
    return state.categories.map(category => {
      return {
        id: category.id,
        text: category.name
      }
    })
  },
  productToCategory(state) {
    return state.productToCategory
  }
}

const actions = {
  getCategories(context) {
    http()
      .get('categories')
      .then(data => {
        console.log('categories', data)
        context.commit('updateCategories', data.data)
      })
  },
  getProductToCategory(context) {
    http()
      .get('product-to-category')
      .then(data => {
        context.commit('updateProductToCategory', data.data)
      })
  }
}

const mutations = {
  updateCategories(state, payload) {
    state.categories = payload
  },
  updateProductToCategory(state, payload) {
    state.productToCategory = payload
  },
  toggleShowInactive(state) {
    state.showInactive = !state.showInactive
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/category.js